import { makeStyles } from '@material-ui/core/styles';
import fonts from 'styles/fonts';
import { colors } from 'styles/colors';

const useStyles = makeStyles({
  bodyContent: {
    flexGrow: 1,

    '& > div:first-child': {
      paddingBottom: '34px',
    },
    '& > div': {
      paddingBottom: '24px',
    },
    '& > div:last-child': {
      paddingBottom: '0',
    },
  },
  gridContent: {
    '& > *': {
      marginTop: '24px',
    },
    '& > *:first-child': {
      marginTop: 0,
    },
  },
  inputList: {
    '& .MuiInputBase-root': {
      height: 'auto',
    },
    '& .MuiIconButton-root': {
      color: colors.black,
    },
  },
  formLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  formInput: {
    color: colors.black,
  },
  formBaseInput: {
    '& .MuiFormHelperText-root': {
      color: colors.gray,
    },
  },
  checklistActivityTitle: {
    fontSize: fonts.sizes.xlarge,
    fontWeight: fonts.weights.medium,
    letterSpacing: '0.15px',
    lineHeight: '24px',
    color: colors.black,
  },
});

export default useStyles;
